export const dictionary = {
  en: {
    Following: 'Following',
    Followers: 'Followers',
    Users: 'Users',
    Likes: 'Likes',
    Follow: 'Follow',
    Next: 'Next',
    Videos: 'Videos',
    Share: 'Share',
    Albums: 'Albums',
    group: 'group',
    'vimeo channel': 'vimeo channel',
    'vimeo group': 'vimeo group',
    'vimeo playlist': 'vimeo playlist',
    'Open in Vimeo': 'Open in Vimeo',
    'Join this': 'Join this',
    'Share on Facebook': 'Share on Facebook',
    'Share on X': 'Share on X',
    'Load More': 'Load More'
  },

  cz: {
    Following: 'Sledovaní',
    Followers: 'Sledující',
    Users: 'Uživatelé',
    Likes: 'Líbí se',
    Follow: 'Sledovat',
    Next: 'Další',
    Videos: 'Videa',
    Share: 'Sdílet',
    Albums: 'Alba',
    group: 'skupina',
    'vimeo channel': 'kanál vimeo',
    'vimeo group': 'skupina vimeo',
    'vimeo playlist': 'vimeo playlist',
    'Open in Vimeo': 'Zobrazit na Vimeo',
    'Join this': 'Připojte se k tomuto',
    'Share on Facebook': 'Sdílet na Facebooku',
    'Share on X': 'Sdílet na X',
    'Load More': 'Načíst další'
  },

  de: {
    Following: 'Folge ich',
    Followers: 'Follower',
    Users: 'Benutzer',
    Likes: 'Likes',
    Follow: 'Folgen',
    Next: 'Nächster',
    Albums: 'Alben',
    Videos: 'Videos',
    Share: 'Teilen',
    group: 'gruppe',
    'vimeo channel': 'vimeo channel',
    'vimeo group': 'Vimeo-Gruppe',
    'vimeo playlist': 'Vimeo-Wiedergabeliste',
    'Open in Vimeo': 'Vis på Vimeo',
    'Join this': 'Mach mit',
    'Share on Facebook': 'Teilen auf Facebook',
    'Share on X': 'Teilen auf X',
    'Load More': 'Weitere anzeigen'
  },

  es: {
    Followers: 'Seguidores',
    Following: 'Siguiendo',
    Users: 'Usuarios',
    Likes: 'Gustos',
    Follow: 'Seguir',
    Next: 'Siguiente',
    'vimeo channel': 'canal vimeo',
    'vimeo group': 'grupo vimeo',
    'vimeo playlist': 'lista de reproducción vimeo',
    'Open in Vimeo': 'Abrir en Vimeo',
    'Join this': 'Únete a este',
    group: 'grupo',
    Videos: 'Videos',
    Share: 'Compartir',
    'Share on Facebook': 'Compartir en Facebook',
    'Share on X': 'Compartir en X',
    'Load More': 'Cargar más',
    Albums: 'Álbumes'
  },

  fr: {
    Followers: 'Suiveurs',
    Following: 'Suivant',
    Users: 'Utilisateurs',
    Likes: 'Aime',
    Follow: 'Suivre',
    Next: 'Prochain',
    'vimeo channel': 'canal vimeo',
    'vimeo group': 'groupe vimeo',
    'vimeo playlist': 'liste de lecture vimeo',
    'Open in Vimeo': 'Ouvert à Vimeo',
    'Join this': 'Rejoindre ce',
    group: 'groupe',
    Videos: 'Vidéos',
    Share: 'Partager',
    'Share on Facebook': 'Partager sur Facebook',
    'Share on X': 'Partager sur X',
    'Load More': 'Charger plus',
    Albums: 'Albums'
  },

  it: {
    Followers: 'Seguaci',
    Following: 'A seguire',
    Users: 'utenti',
    Likes: 'Piace',
    Follow: 'Seguire',
    Next: 'Il prossimo',
    'vimeo channel': 'canale vimeo',
    'vimeo group': 'gruppo vimeo',
    'vimeo playlist': 'playlist di Vimeo',
    'Open in Vimeo': 'Apri in Vimeo',
    'Join this': 'Unisciti a questo',
    group: 'gruppo',
    Videos: 'Video',
    Share: 'Condividi',
    'Share on Facebook': 'Condividi su Facebook',
    'Share on X': 'Condividi su X',
    'Load More': 'Carica di più',
    Albums: 'Album'
  },

  hu: {
    Followers: 'Követő',
    Following: 'Következő',
    Users: 'Felhasználók',
    Likes: 'Kedveltek',
    Follow: 'Kövesse',
    Next: 'Következő',
    'vimeo channel': 'vimeo csatorna',
    'vimeo group': 'vimeo csoport',
    'vimeo playlist': 'vimeo lejátszási lista',
    'Open in Vimeo': 'Nyitott Vimeóban',
    'Join this': 'Csatlakozzon ehhez',
    group: 'csoport',
    Videos: 'Videók',
    Share: 'Megosztás',
    'Share on Facebook': 'Megosztás a Facebookon',
    'Share on X': 'Megosztás az X-en',
    'Load More': 'Tovább',
    Albums: 'Albumok'
  },

  nl: {
    Followers: 'Volgers',
    Following: 'Volgend op',
    Users: 'Gebruikers',
    Likes: 'Sympathieën',
    Follow: 'Volgen',
    Next: 'Volgende',
    'vimeo channel': 'vimeo kanaal',
    'vimeo group': 'vimeo groep',
    'vimeo playlist': 'vimeo-afspeellijst',
    'Open in Vimeo': 'Open in Vimeo',
    'Join this': 'Doe mee',
    group: 'groep',
    Videos: "Video's",
    Share: 'Delen',
    'Share on Facebook': 'Delen op Facebook',
    'Share on X': 'Delen op X',
    'Load More': 'Meer laden',
    Albums: 'Albums'
  },

  no: {
    Followers: 'etterfølgere',
    Following: 'Følgende',
    Users: 'brukere',
    Likes: 'liker',
    Follow: 'Følg',
    Next: 'neste',
    'vimeo channel': 'vimeo kanal',
    'vimeo group': 'vimeo gruppe',
    'vimeo playlist': 'vimeo spilleliste',
    'Open in Vimeo': 'Åpent i Vimeo',
    'Join this': 'Bli med på dette',
    group: 'gruppe',
    Videos: 'Filmer',
    Share: 'Del',
    'Share on Facebook': 'Del på Facebook',
    'Share on X': 'Del på X',
    'Load More': 'Last flere',
    Albums: 'Album'
  },

  pl: {
    Followers: 'Obserwujący',
    Following: 'Następujący',
    Users: 'Użytkownicy',
    Likes: 'Lubi',
    Follow: 'Śledź',
    Next: 'Dalej',
    'vimeo channel': 'Kanał vimeo',
    'vimeo group': 'Grupa vimeo',
    'vimeo playlist': 'Lista odtwarzania vimeo',
    'Open in Vimeo': 'Otwórz w Vimeo',
    'Join this': 'Dołącz do tego',
    group: 'grupa',
    Videos: 'Filmy',
    Share: 'Udostępnij',
    'Share on Facebook': 'Udostępnij na Facebooku',
    'Share on X': 'Udostępnij na X',
    'Load More': 'Załaduj więcej',
    Albums: 'Albumy'
  },

  pt: {
    Followers: 'Seguidores',
    Following: 'Seguindo',
    Users: 'Usuários',
    Likes: 'Gosta',
    Follow: 'Siga',
    Next: 'Próximo',
    'vimeo channel': 'canal vimeo',
    'vimeo group': 'grupo vimeo',
    'vimeo playlist': 'playlist vimeo',
    'Open in Vimeo': 'Abra no Vimeo',
    'Join this': 'Junte-se a isto',
    group: 'grupo',
    Videos: 'Vídeos',
    Share: 'Compartilhar',
    'Share on Facebook': 'Compartilhar no Facebook',
    'Share on X': 'Compartilhar no X',
    'Load More': 'Carregar mais',
    Albums: 'Álbuns'
  },

  ro: {
    Followers: 'Urmează',
    Following: 'În urma',
    Users: 'Utilizatori',
    Likes: 'Îmi place',
    Follow: 'Urmați',
    Next: 'Următorul',
    'vimeo channel': 'canal vimeo',
    'vimeo group': 'grup vimeo',
    'vimeo playlist': 'playlist vimeo',
    'Open in Vimeo': 'Deschideți în Vimeo',
    'Join this': 'Alăturați-vă',
    group: 'grup',
    Videos: 'Video-uri',
    Share: 'Distribuie',
    'Share on Facebook': 'Distribuie pe Facebook',
    'Share on X': 'Distribuie pe X',
    'Load More': 'Vezi mai multe',
    Albums: 'Albume'
  },

  fi: {
    Followers: 'Seuraajat',
    Following: 'Seuraava',
    Users: 'Käyttäjät',
    Likes: 'Tykkää',
    Follow: 'Seuraa',
    Next: 'Seuraava',
    'vimeo channel': 'vimeo-kanava',
    'vimeo group': 'vimeo-ryhmä',
    'vimeo playlist': 'vimeo-soittolista',
    'Open in Vimeo': 'Avaa Vimeossa',
    'Join this': 'Liity tähän',
    group: 'ryhmä',
    Videos: 'Videot',
    Share: 'Jaa',
    'Share on Facebook': 'Jaa Facebookissa',
    'Share on X': 'Jaa X:ssä',
    'Load More': 'Lataa lisää',
    Albums: 'Albumit'
  },

  sv: {
    Followers: 'Följare',
    Following: 'Följande',
    Users: 'Användare',
    Likes: 'gillar',
    Follow: 'Följ',
    Next: 'Nästa',
    'vimeo channel': 'Vimeo kanal',
    'vimeo group': 'Vimeo-gruppen',
    'vimeo playlist': 'Vimeo spellista',
    'Open in Vimeo': 'Öppna i Vimeo',
    'Join this': 'Gå med i det här',
    group: 'grupp',
    Videos: 'Filmer',
    Share: 'Dela',
    'Share on Facebook': 'Dela på Facebook',
    'Share on X': 'Dela på X',
    'Load More': 'Ladda fler',
    Albums: 'Bildkataloger'
  },

  tr: {
    Followers: 'Takipçiler',
    Following: 'takip ediyor',
    Users: 'Kullanıcılar',
    Likes: 'Beğeniler',
    Follow: 'izleyin',
    Next: 'Sonraki',
    'vimeo channel': 'vimeo kanalı',
    'vimeo group': 'vimeo grubu',
    'vimeo playlist': 'vimeo çalma listesi',
    'Open in Vimeo': 'Vimeo’da aç',
    'Join this': 'Buna katılın',
    group: 'grup',
    Videos: 'Vidyolar',
    Share: 'Paylaş',
    'Share on Facebook': "Facebook'ta Paylaş",
    'Share on X': "X'te Paylaş",
    'Load More': 'Daha fazla yükle',
    Albums: 'Albümler'
  },

  ru: {
    Followers: 'Подписчики',
    Following: 'Подписан',
    Users: 'Пользователи',
    Likes: 'Лайки',
    Follow: 'Подписаться',
    Next: 'След.',
    'vimeo channel': 'Vimeo канал',
    'vimeo group': 'Vimeo группа',
    'vimeo playlist': 'Vimeo плейлист',
    'Open in Vimeo': 'Открыть в Vimeo',
    'Join this': 'Вступить в эту',
    group: 'группу',
    Videos: 'Видео',
    Share: 'Поделиться',
    'Share on Facebook': 'Поделиться на Facebook',
    'Share on X': 'Поделиться в X',
    'Load More': 'Загрузить еще',
    Albums: 'Альбомы'
  },

  ar: {
    Followers: 'أتباع',
    Following: 'التالية',
    Users: 'المستخدمين',
    Likes: 'يحب',
    Follow: 'اتبع',
    Next: 'التالي',
    'vimeo channel': 'قناة vimeo',
    'vimeo group': 'مجموعة vimeo',
    'vimeo playlist': 'vimeo قائمة التشغيل',
    'Open in Vimeo': 'فتح في فيميو',
    'Join this': 'انضم إلى هذا',
    group: 'المجموعة',
    Videos: 'الفيديو',
    Share: 'مشاركة',
    'Share on Facebook': 'مشاركة على فيس بوك',
    'Share on X': 'مشاركة على X',
    'Load More': 'اظهار المزيد',
    Albums: 'البومات'
  },

  dk: {
    Followers: 'Følgere',
    Following: 'Følgende',
    Users: 'Brugere',
    Likes: 'Kan lide',
    Follow: 'Følg',
    Next: 'Næste',
    'vimeo channel': 'Vimeo kanal',
    'vimeo group': 'Vimeo gruppe',
    'vimeo playlist': 'Vimeo spilleliste',
    'Open in Vimeo': 'Åbn i Vimeo',
    'Join this': 'Tilmeld dig dette',
    group: 'gruppe',
    Videos: 'Videoer',
    Share: 'Del',
    'Share on Facebook': 'Del på Facebook',
    'Share on X': 'Del på X',
    'Load More': 'Indlæs flere',
    Albums: 'Albummer'
  },

  lt: {
    Followers: 'Stebėtojai',
    Following: 'Po',
    Users: 'Vartotojai',
    Likes: 'Mėgsta',
    Follow: 'Sekite',
    Next: 'Toliau',
    'vimeo channel': 'vimeo kanalas',
    'vimeo group': 'vimeo grupė',
    'vimeo playlist': 'vimeo grojaraštis',
    'Open in Vimeo': 'Atidaryti Vimeo',
    'Join this': 'Prisijunkite',
    group: 'grupė',
    Videos: 'Vaizdo įrašai',
    Share: 'Dalintis',
    'Share on Facebook': 'Dalintis Facebook',
    'Share on X': 'Dalintis X',
    'Load More': 'Žiūrėti daugiau',
    Albums: 'Albumai'
  },

  'he-IL': {
    Followers: 'עוקבים',
    Following: 'להלן',
    Users: 'משתמשים',
    Likes: 'אוהב',
    Follow: 'בצע',
    Next: 'הבא',
    'vimeo channel': 'ערוץ vimeo',
    'vimeo group': 'קבוצת vimeo',
    'vimeo playlist': 'רשימת השמעה vimeo',
    'Open in Vimeo': 'פתח ב Vimeo',
    'Join this': 'הצטרף לזה',
    group: 'הקבוצה',
    Videos: 'וידאו',
    Share: 'שיתוף',
    'Share on Facebook': 'שיתוף בפייסבוק',
    'Share on X': 'שיתוף ב-X',
    'Load More': 'טען עוד',
    Albums: 'אלבומים'
  },

  mk: {
    Followers: 'Следбеници',
    Following: 'По следното',
    Users: 'Корисници',
    Likes: 'Допаѓања',
    Follow: 'Следете',
    Next: 'Следно',
    'vimeo channel': 'Vimeo канал',
    'vimeo group': 'Vimeo група',
    'vimeo playlist': 'Vimeo плејлиста',
    'Open in Vimeo': 'Отвори во Vimeo',
    'Join this': 'Придружете се кон ова',
    group: 'група',
    Videos: 'Видео',
    Share: 'Сподели',
    'Share on Facebook': 'Сподели на Facebook',
    'Share on X': 'Сподели на X',
    'Load More': 'Види повеќе',
    Albums: 'Албуми'
  },

  hi: {
    Followers: 'अनुयायी',
    Following: 'निम्नलिखित',
    Users: 'उपयोगकर्ता',
    Likes: ' यह पसंद है',
    Follow: 'का पालन करें',
    Next: 'आगामी',
    'vimeo channel': 'वीमियो चैनल',
    'vimeo group': 'वीमो ग्रुप',
    'vimeo playlist': 'वीमियो प्लेलिस्ट',
    'Open in Vimeo': 'वीमो में खुला',
    'Join this': 'इस में शामिल हों',
    group: 'समूह',
    Videos: 'वीडियो',
    Share: 'साझा करें',
    'Share on Facebook': 'फेसबुक पर सांझा करें',
    'Share on X': 'X पर साझा करें',
    'Load More': "और लोड करें'",
    Albums: 'एल्बम'
  },

  ja: {
    Followers: 'フォロワー',
    Following: 'フォロー中',
    Users: 'ユーザー',
    Likes: '好きなもの',
    Follow: '従ってください',
    Next: '次',
    'vimeo channel': 'ビメオチャンネル',
    'vimeo group': 'ビメオグループ',
    'vimeo playlist': 'vimeoプレイリスト',
    'Open in Vimeo': 'Vimeoで開く',
    'Join this': 'これに参加',
    group: 'グループ',
    Videos: '動画',
    Share: 'シェア',
    'Share on Facebook': 'Facebookでシェア',
    'Share on X': 'Xでシェア',
    'Load More': 'もっと読み込む',
    Albums: 'アルバム'
  },

  'zh-cn': {
    Followers: '追随者',
    Following: '以下',
    Users: '用户',
    Likes: '喜欢',
    Follow: '跟随',
    Next: '下一个',
    'vimeo channel': 'vimeo频道',
    'vimeo group': 'vimeo 组',
    'vimeo playlist': 'vimeo播放列表',
    'Open in Vimeo': '在Vimeo开放',
    'Join this': '加入这个',
    group: '组',
    Videos: '视频',
    Share: '分享',
    'Share on Facebook': '在脸书上分享',
    'Share on X': '分享到X',
    'Load More': '装载更多',
    Albums: '专辑'
  },

  'zh-tw': {
    Followers: '追隨者',
    Following: '以下',
    Users: '用戶',
    Likes: '喜歡',
    Follow: '跟隨',
    Next: '下一個',
    'vimeo channel': 'vimeo頻道',
    'vimeo group': 'vimeo 組',
    'vimeo playlist': 'vimeo播放列表',
    'Open in Vimeo': '在Vimeo開放',
    'Join this': '加入這個',
    group: '組',
    Videos: '視頻',
    Share: '分享',
    'Share on Facebook': '在臉書上分享',
    'Share on X': '分享到X',
    'Load More': '裝載更多',
    Albums: '專輯'
  }
};
